export default {
  "YH-sale": {
    "ts": 'yhapp.mc',
    "clueFrom": "YH-sale",
    "clueFromCode": "用户APP-买车"
  },
  "SJQD-banner": {
    "ts": 'sj.qd.banne',
    "clueFrom": "SJQD-banner",
    "clueFromCode": "司机抢单-banner"
  },
  "SJ-wallet-banner": {
    "ts": 'sj.qb.banne',
    "clueFrom": "SJ-wallet-banner",
    "clueFromCode": "司机钱包banner"
  },
  "SJZX-icon": {
    "ts": 'sj.grzx.icon',
    "clueFrom": "SJZX-icon",
    "clueFromCode": "司机个人中心-icon"
  },
  "SJHD-banner": {
    "ts": 'sjhd.banne',
    "clueFrom": "SJHD-banner",
    "clueFromCode": "司机活动-banner"
  },
  "YH-TC": {
    "ts": 'yhapp.dc',
    "clueFrom": "YH-TC",
    "clueFromCode": "用户APP-弹窗"
  },
  "YH-HD": {
    "ts": 'yhapp.hdl',
    "clueFrom": "YH-HD",
    "clueFromCode": "用户APP-活动栏"
  },
  "XCX-GC": {
    "ts": 'gcxcx',
    "clueFrom": "XCX-GC",
    "clueFromCode": "购车小程序"
  },
  "ZMT-wxfwh": {
    "ts": "hll.fwh",
    "clueFrom": "ZMT-wxfwh",
    "clueFromCode": "货拉拉服务号"
  },
  "ZMT-wxdyh": {
    "ts": 'hll.dyh',
    "clueFrom": "ZMT-wxdyh",
    "clueFromCode": "货拉拉订阅号"
  },
  "ZMT-wxpth": {
    "ts": 'hll.pth',
    "clueFrom": "ZMT-wxpth",
    "clueFromCode": "货拉拉平台号"
  },
  "ZMT-wxgch": {
    "ts": 'hll.gch',
    "clueFrom": "ZMT-wxgch",
    "clueFromCode": "货拉拉购车号"
  },
  "ZMT-AliPay": {
    "ts": 'zfb.shh',
    "clueFrom": "ZMT-AliPay",
    "clueFromCode": "支付宝生活号"
  },
  "XCX-huolala": {
    "ts": 'hyxcx',
    "clueFrom": "XCX-huolala",
    "clueFromCode": "货运小程序"
  },
  "PZ-baidu-yd": {
    "ts": "bdpz.sem.yd",
    "clueFrom": "PZ-baidu-yd",
    "clueFromCode": "百度品专SEM-移动"
  },
  "PZ-shenma-yd": {
    "ts": 'smpz.yd',
    "clueFrom": "PZ-shenma-yd",
    "clueFromCode": "神马品专-移动"
  },
  "PZ-sougou-yd": {
    "ts": "sgpz.yd",
    "clueFrom": "PZ-sougou-yd",
    "clueFromCode": "搜狗品专-移动"
  },
  "QT-SMS": {
    "ts": 'sms.dx',
    "clueFrom": "QT-SMS",
    "clueFromCode": "SMS短信"
  },
  "YH-push": {
    "ts": 'yh.push',
    "clueFrom": "YH-push",
    "clueFromCode": "用户push"
  },
  "SJpush": {
    "ts": 'sj.push',
    "clueFrom": "SJpush",
    "clueFromCode": "司机push"
  },
  "SJPMD": {
    "ts": 'sj.pmd',
    "clueFrom": "SJPMD",
    "clueFromCode": "司机跑马灯"
  },
  "SJFL-icon": {
    "ts": 'sjfl.icon',
    "clueFrom": "SJFL-icon",
    "clueFromCode": "司机福利-icon"
  },
  // "SJFL-banner": {
  //   "ts": 'sjfl.banne',
  //   "clueFrom": "SJFL-banner",
  //   "clueFromCode": "司机福利-banner"
  // },
  "SJFL-banner-two": {
    "ts": 'sjfl.banne',
    "clueFrom": "SJFL-banner-two",
    "clueFromCode": "司机福利-banner"
  },
  "SJTC": {
    "ts": "sj.dc",
    "clueFrom": "SJTC",
    "clueFromCode": "司机弹窗"
  },
  "SJXX": {
    "ts": 'sj.xx',
    "clueFrom": "SJXX",
    "clueFromCode": "司机信箱"
  },
  "self-baidusem": {
    "ts": 'ztf.bd',
    "clueFrom": "self-baidusem",
    "clueFromCode": "自投放-百度"
  },
  "SW-jinfubaijia": {
    "ts": 'jfbj',
    "clueFrom": "SW-jinfubaijia",
    "clueFromCode": "金服百家"
  },
  "elf-jrtt": {
    "ts": '',
    "clueFrom": "elf-jrtt",
    "clueFromCode": "自投放-今日头条"
  },
  'share34': {
    "ts": '',
    "clueFrom": "share34",
    "clueFromCode": "分享留资"
  },
  'xcdbnr': {
    "ts": '',
    "clueFrom": "xcdbnr",
    "clueFromCode": "行程单底部banner"
  },
  'sjtuisong': {
    "ts": '',
    "clueFrom": "sjtuisong",
    "clueFromCode": "司机推送"
  },
  'xcdmail': {
    "ts": '',
    "clueFrom": "xcdmail",
    "clueFromCode": "行程单邮件素材"
  },
  'yhlahuo': {
    "ts": '',
    "clueFrom": "yhlahuo",
    "clueFromCode": "用户拉货节"
  },
  'yhbanner': {
    "ts": '',
    "clueFrom": "yhbanner",
    "clueFromCode": "用户首页banner"
  },
  'YH-SY': {
    "ts": '',
    "clueFrom": "YH-SY",
    "clueFromCode": "用户APP-首页banner"
  },
  'hllxcx-grzx': {
    "ts": '',
    "clueFrom": "hllxcx-grzx",
    "clueFromCode": "货运小程序-个人中心"
  },
  'ZMT-jrtt': {
    "ts": '',
    "clueFrom": "ZMT-jrtt",
    "clueFromCode": "今日头条号"
  },
  'ZMT-wxss': {
    "ts": '',
    "clueFrom": "ZMT-wxss",
    "clueFromCode": "微信搜索"
  },
  'lalamc_mp_hll_YH-TC': {
    "ts": '',
    "clueFrom": "lalamc_mp_hll_YH-TC",
    "clueFromCode": "购车小程序-用户app弹窗"
  },
  'hllxcx-tc': {
    "ts": '',
    "clueFrom": "hllxcx-tc",
    "clueFromCode": "货运小程序-弹窗"
  },
  'qcxl-1': {
    "ts": '',
    "clueFrom": "qcxl-1",
    "clueFromCode": "修理1"
  },
  'qcxl-2': {
    "ts": '',
    "clueFrom": "qcxl-2",
    "clueFromCode": "修理2"
  },
  'qcxl-3': {
    "ts": '',
    "clueFrom": "qcxl-3",
    "clueFromCode": "修理3"
  },
  'qcxl-4': {
    "ts": '',
    "clueFrom": "qcxl-4",
    "clueFromCode": "修理4"
  },
  'qcmr-1': {
    "ts": '',
    "clueFrom": "qcmr-1",
    "clueFromCode": "美容1"
  },
  'qcmr-2': {
    "ts": '',
    "clueFrom": "qcmr-2",
    "clueFromCode": "美容2"
  },
  'qcmr-3': {
    "ts": '',
    "clueFrom": "qcmr-3",
    "clueFromCode": "美容3"
  },
  'bld-1': {
    "ts": '',
    "clueFrom": "bld-1",
    "clueFromCode": "便利店1"
  },
  'bld-2': {
    "ts": '',
    "clueFrom": "bld-2",
    "clueFromCode": "便利店2"
  },
  'bld-3': {
    "ts": '',
    "clueFrom": "bld-3",
    "clueFromCode": "便利店3"
  },
  'lbdj': {
    "ts": '',
    "clueFrom": "lbdj",
    "clueFromCode": "鲁班到家"
  },
  // 'ZMT-wxpth': {
  //   "ts": '',
  //   "clueFrom": "ZMT-wxpth",
  //   "clueFromCode": "货拉拉平台号"
  // },
}
